// extracted by mini-css-extract-plugin
export default {"container":"verify_container__X0gBT","loadingSpinner":"verify_loadingSpinner__EP7K3"};